import { Component, Input, OnChanges } from '@angular/core';

@Component({

  selector: 'app-counter',

  templateUrl: './can-counter.component.html',

  styleUrls: ['./can-counter.component.css']

})

export class CanCounterComponent implements OnChanges {
  
  @Input() percent = 100;
  @Input() height = 80;

  half = 0;
  dashOffset = 0;


  ngOnChanges(): void {
    this.setBattery();
  }

  setBattery() {

    const radius = 100;
    const p = Math.max(0, Math.min(100, this.percent));

    const full = 2 * Math.PI * radius;
    this.half = full / 2;

    

    this.dashOffset = this.half * (1 - p / 100);
  }
}
